var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cardDemandApplyDrawer" },
    [
      _c(
        "div",
        { staticClass: "con__style" },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "form",
              attrs: { model: _vm.form, "label-width": "110px", size: "small" },
            },
            [
              _c("div", { staticClass: "section-title" }, [_vm._v("基本信息")]),
              _c(
                "div",
                { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { flex: "1", "min-width": "300px" },
                      attrs: {
                        label: "客户ID",
                        prop: "customer_id",
                        rules: [
                          {
                            required: true,
                            message: "请输入客户ID",
                            trigger: "blur",
                          },
                          {
                            pattern: /^[1-9]\d*$/,
                            message: "请输入正整数",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "input__width",
                        attrs: { placeholder: "请输入" },
                        on: { blur: _vm.handleCustomerBlur },
                        model: {
                          value: _vm.form.customer_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "customer_id", $$v)
                          },
                          expression: "form.customer_id",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: {
                        flex: "1",
                        "min-width": "300px",
                        "margin-left": "20px",
                      },
                      attrs: { label: "领用人", prop: "user_name" },
                    },
                    [
                      _c("el-input", {
                        staticClass: "input__width",
                        attrs: { disabled: "", placeholder: "-" },
                        model: {
                          value: _vm.form.user_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "user_name", $$v)
                          },
                          expression: "form.user_name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { flex: "1", "min-width": "300px" },
                      attrs: {
                        label: "业务类型",
                        prop: "card_group_type_id",
                        rules: [
                          {
                            required: true,
                            message: "请选择业务类型",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "input__width",
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择",
                          },
                          on: { change: _vm.changeBusinessType },
                          model: {
                            value: _vm.form.card_group_type_id,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "card_group_type_id",
                                _vm._n($$v)
                              )
                            },
                            expression: "form.card_group_type_id",
                          },
                        },
                        _vm._l(_vm.businessTypeList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: Number(item.id) },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: {
                        flex: "1",
                        "min-width": "300px",
                        "margin-left": "20px",
                      },
                      attrs: {
                        label: "卡类型",
                        prop: "card_type",
                        rules: [
                          {
                            required: true,
                            message: "请选择卡类型",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "input__width",
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.form.card_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "card_type", $$v)
                            },
                            expression: "form.card_type",
                          },
                        },
                        _vm._l(_vm.cardTypeList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { flex: "1", "min-width": "300px" },
                      attrs: {
                        label: "预计领卡日期",
                        prop: "expected_card_date",
                        rules: [
                          {
                            required: true,
                            message: "请选择预计领卡日期",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticClass: "input__width",
                        attrs: {
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          format: "yyyy-MM-dd",
                          placeholder: "请选择",
                        },
                        model: {
                          value: _vm.form.expected_card_date,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "expected_card_date", $$v)
                          },
                          expression: "form.expected_card_date",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: {
                        flex: "1",
                        "min-width": "300px",
                        "margin-left": "20px",
                      },
                      attrs: {
                        label: "预计领卡时间",
                        prop: "expected_card_time",
                        rules: [
                          {
                            required: true,
                            message: "请选择预计领卡时间",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.expected_card_time,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "expected_card_time", $$v)
                            },
                            expression: "form.expected_card_time",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "11:00" } }, [
                            _vm._v("11:00"),
                          ]),
                          _c("el-radio", { attrs: { label: "14:00" } }, [
                            _vm._v("14:00"),
                          ]),
                          _c("el-radio", { attrs: { label: "17:00" } }, [
                            _vm._v("17:00"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { flex: "1", "min-width": "300px" },
                      attrs: { label: "领用备注", prop: "note" },
                    },
                    [
                      _c("el-input", {
                        staticClass: "input__width",
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 4 },
                          maxlength: 500,
                          "show-word-limit": "",
                          placeholder: "请输入领用备注",
                        },
                        model: {
                          value: _vm.form.note,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "note", $$v)
                          },
                          expression: "form.note",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-divider", { staticStyle: { margin: "20px 0" } }),
              _c(
                "div",
                { staticClass: "section-title" },
                [
                  _c("span", [_vm._v("领取物料明细")]),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "20px" },
                      attrs: {
                        type: "primary",
                        size: "mini",
                        icon: "el-icon-plus",
                      },
                      on: { click: _vm.handleAddMaterial },
                    },
                    [_vm._v("添加物料")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%", margin: "10px 0 50px 0" },
                  attrs: {
                    border: "",
                    "header-cell-style": {
                      background: "#F1F1F1",
                      color: "#333333",
                    },
                    data: _vm.form.material_arr,
                    "tooltip-effect": "dark",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "序号",
                      width: "60px",
                      type: "index",
                      align: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "物料编码",
                      width: "90px",
                      prop: "material_id",
                      align: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "物料预览图",
                      width: "120px",
                      prop: "pre_img",
                      align: "left",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.pre_img
                              ? _c("el-image", {
                                  staticStyle: {
                                    height: "50px",
                                    width: "70px",
                                  },
                                  attrs: {
                                    src: scope.row.pre_img,
                                    "preview-src-list": [scope.row.pre_img],
                                    fit: "contain",
                                  },
                                })
                              : _c("span", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "物料名称",
                      width: "150px",
                      prop: "name",
                      align: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "物料类型",
                      width: "90px",
                      prop: "material_type_des",
                      align: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "印刷类型",
                      width: "90px",
                      prop: "print_type_des",
                      align: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "申请领取数量",
                      width: "130px",
                      align: "left",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "0" },
                                attrs: {
                                  prop:
                                    "material_arr." +
                                    scope.$index +
                                    ".apply_num",
                                  rules: [
                                    {
                                      required: true,
                                      message: "请输入领取数量",
                                      trigger: "change",
                                    },
                                    {
                                      pattern: /^[1-9]\d*$/,
                                      message: "请输入大于0的整数",
                                      trigger: "change",
                                    },
                                  ],
                                  "label-width": "0",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入",
                                    size: "mini",
                                  },
                                  model: {
                                    value: scope.row.apply_num,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "apply_num", $$v)
                                    },
                                    expression: "scope.row.apply_num",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "业务类型/卡类型",
                      "min-width": "180px",
                      align: "left",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  (scope.row.card_bin_group_des || "-") +
                                    " / " +
                                    (scope.row.card_type_des || "-")
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "领取仓库",
                      width: "120px",
                      prop: "branch_office_name",
                      align: "left",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.branch_office_name || "-") +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "库存",
                      width: "90px",
                      prop: "stock_count",
                      align: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "100px",
                      align: "left",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticStyle: { color: "red" },
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleRemove(scope.$index)
                                  },
                                },
                              },
                              [_vm._v("移除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "small",
                loading: _vm.submitLoading,
              },
              on: { click: _vm.submitForm },
            },
            [_vm._v("提交")]
          ),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawerSelect,
            size: "75%",
            title: "添加物料",
            "append-to-body": true,
            "custom-class": "myDrawer",
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerSelect = $event
            },
          },
        },
        [
          _c("CardDemandMaterialSelectDrawer", {
            ref: "CardDemandMaterialSelectDrawer",
            attrs: {
              "existing-card-coupon-types": _vm.existingCardCouponTypes,
              "is-sale-visible": "1",
            },
            on: {
              selected: _vm.handleMaterialSelected,
              close: function ($event) {
                _vm.drawerSelect = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }